import { getFullUrl } from 'hubspot-url-utils';
import baseHttpClient from '../../utils/apiClient';
const API_BASE = `${getFullUrl('app-api')}/commenting/v1/commenting`;
export const getComments = ({
  callObjectId,
  setSkipRefresh
}) => baseHttpClient.get(`${API_BASE}/ENGAGEMENT/${callObjectId}`, {
  setSkipRefresh
});
export const createComment = ({
  objectType = 'ENGAGEMENT',
  message,
  callObjectId,
  atMentionsOwnerIds,
  ctaUrl
}) => baseHttpClient.post(API_BASE, {
  data: {
    objectType,
    objectId: callObjectId,
    type: 'COMMENT',
    message,
    atMentionsOwnerIds,
    ctaUrl
  }
});
export const deleteComment = commentId => baseHttpClient.delete(`${API_BASE}/${commentId}`);
export const updateComment = ({
  commentId,
  message,
  atMentionsOwnerIds,
  ctaUrl
}) => baseHttpClient.patch(`${API_BASE}/${commentId}`, {
  data: {
    message,
    ctaUrl,
    atMentionsOwnerIds
  }
});